import window from 'window'

const handlers = new Map()

export function addBeforeUnload (tag, fnOrText) {
  let handler

  if (typeof fnOrText === 'function') {
    handler = fnOrText
  } else if (typeof fnOrText === 'string') {
    handler = (e) => {
      e.returnValue = fnOrText
      return fnOrText
    }
  }

  handlers.set(tag, handler)
  window.addEventListener('beforeunload', handler)
}

export function removeBeforeUnload (tag) {
  window.removeEventListener('beforeunload', handlers.get(tag))
}



// WEBPACK FOOTER //
// ./src/lib/before-unload.js